/** Get Dashboard Chart data */
export const API_SUCCESS = "API_SUCCESS";
export const API_FAIL = "API_FAIL";
export const GET_CHARTS_DATA = "GET_CHARTS_DATA";

export const GET_TASK_DATA = "GET_TASK_DATA";
export const GET_TASK_DATA_SUCCESS = "GET_TASK_DATA_SUCCESS";
export const GET_TASK_DATA_FAIL = "GET_TASK_DATA_FAIL";

export const APPROVE_TASK = "APPROVE_TASK";
export const APPROVE_TASK_SUCCESS = "APPROVE_TASK_SUCCESS";
export const APPROVE_TASK_FAIL = "APPROVE_TASK_FAIL";

// for team
export const TEAM_DASHBOARD_LIST = "TEAM_DASHBOARD_LIST";
export const TEAM_DASHBOARD_LIST_FAIL = "TEAM_DASHBOARD_LIST_FAIL";
export const TEAM_DASHBOARD_LIST_SUCCESS = "TEAM_DASHBOARD_LIST_SUCCESS";

export const TEAM_ACTION = "TEAM_ACTION";
export const TEAM_ACTION_SUCCESS = "TEAM_ACTION_SUCCESS";
export const TEAM_ACTION_FAIL = "TEAM_ACTION_FAIL";

export const TEAM_SHIFT_START_ACTION = "TEAM_SHIFT_START_ACTION";
export const TEAM_SHIFT_START_ACTION_SUCCESS = "TEAM_SHIFT_START_ACTION_SUCCESS";
export const TEAM_SHIFT_START_ACTION_FAIL = "TEAM_SHIFT_START_ACTION_FAIL";

export const TEAM_SHIFT_END_ACTION = "TEAM_SHIFT_END_ACTION";
export const TEAM_SHIFT_END_ACTION_SUCCESS = "TEAM_SHIFT_END_ACTION_SUCCESS";
export const TEAM_SHIFT_END_ACTION_FAIL = "TEAM_SHIFT_END_ACTION_FAIL";

export const TEAM_TASK_LIST = "TEAM_TASK_LIST";
export const TEAM_TASK_LIST_SUCCESS = "TEAM_TASK_LIST_SUCCESS";
export const TEAM_TASK_LIST_FAIL = "TEAM_TASK_LIST_FAIL";
